<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-form ref="form" lazy-validation>
      <v-card
        elevation="3"
        style="border: 1px solid #e0e0e0"
        class="mb-6 pt-3 pb-3"
      >
        <v-row>
          <v-col cols="12" lg="6" class="pb-0">
            <v-text-field
              :rules="[rules.required]"
              v-model="bookInformation.bookname"
              class="mx-3"
              label="Book Name"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" lg="6" class="pb-0">
            <v-text-field
              v-model="bookInformation.bookdsecription"
              class="mx-3"
              label="Book Dsecription"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col
            v-if="bookInformation.Lang != null"
            cols="12"
            lg="6"
            class="pb-0"
          >
            <v-autocomplete
              :rules="[rules.required]"
              v-model="bookInformation.langid"
              class="mx-3"
              :items="listLang"
              dense
              label="Lang"
              outlined
              item-text="langname"
              item-value="langid"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" lg="6" class="pb-0">
            <v-autocomplete
              :rules="[rules.requiredArray]"
              v-model="categoriesObject"
              :items="categoriesObject"
              outlined
              dense
              :readonly="true"
              chips
              class="mx-3"
              small-chips
              label="Categories"
              multiple
              item-text="categoryname"
              item-value="categoryid"
              @focus="dialogCategoryTree = true"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" lg="6" class="pb-0">
            <v-autocomplete
              clearable
              v-if="bookInformation.author != null"
              :search-input.sync="authorNameSearch"
              v-model="bookInformation.author.authorid"
              class="mx-3"
              :items="listAuthors"
              dense
              label="Author Name"
              outlined
              item-text="authorname"
              item-value="authorid"
              @keyup="searchAuthor()"
              @keyup.ctrl.enter="addDialogAuthor = true"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" lg="6" class="pb-0">
            <v-text-field
              v-model="bookInformation.booklink"
              class="mx-3"
              label="Book Drive Link"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" lg="6" class="pb-0">
            <v-autocomplete
              clearable
              v-if="bookInformation.publisher != null"
              :search-input.sync="publisherNameSearch"
              v-model="bookInformation.publisher.publisherid"
              class="mx-3"
              :items="listPublishers"
              dense
              label="Publisher Name"
              :rules="[rules.required]"
              outlined
              item-text="publishername"
              item-value="publisherid"
              @keyup="searchPublishers()"
              @keyup.ctrl.enter="addDialogPublisher = true"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" lg="6" class="pb-0">
            <v-text-field
              clearable
              v-if="bookInformation.publisher != null "
              v-model="bookInformation.publisher.year"
              class="mx-3"
              label="Published Year"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6" class="pb-0">
            <v-switch
              class="mx-3"
              v-model="bookInformation.isdownloadable"
              flat
              label="Is downloadable"
            ></v-switch>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        elevation="3"
        style="border: 1px solid #e0e0e0"
        class="mb-6 pt-3 pb-3"
      >
        <v-simple-table v-if="bookInformation.MetaData != null">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 45%" class="text-left">Meta Name</th>
                <th style="width: 45%" class="text-left">Meta Value</th>
                <th style="width: 10%" class="text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in bookInformation.MetaData"
                :key="index"
              >
                <td style="width: 45%" class="text-left">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        class="mt-6"
                        label="Meta Value"
                        :rules="[rules.required]"
                        v-model="item.name"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </td>
                <td style="width: 45%" class="text-left">
                  <v-text-field
                    class="mt-6"
                    label="Meta Value"
                    :rules="[rules.required]"
                    v-model="item.value"
                    outlined
                    dense
                  >
                  </v-text-field>
                </td>
                <td style="width: 10%" class="text-left pb-4">
                  <span style="cursor: pointer" @click="removerMeta(index)"
                    ><i class="status fa fa-times-circle red--text"></i
                  ></span>
                </td>
              </tr>
              <tr style="background-color: #ffff">
                <td></td>
                <td></td>
                <td>
                  <v-btn
                    color="success"
                    @click="addMeta"
                    class="mt-3 ml-3 float-right"
                  >
                    Add Meta
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <v-col cols="12" class="pb-0">
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-3"
            color="primary"
            @click="submit()"
            :loading="loadingAdd"
          >
            Submit
          </v-btn>
        </v-card-actions>

        <v-spacer></v-spacer>
      </v-col>
    </v-form>
    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
    <AddAuthor
      :addDialog="addDialogAuthor"
      v-on:DialogClose="DialogClose($event)"
    />
    <AddPublisher
      :addDialog="addDialogPublisher"
      v-on:DialogClose="DialogClose($event)"
    />
  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";
import AddAuthor from "@/components/Authors/AddAuthor";
import AddPublisher from "@/components/Publishers/AddPublisher";

export default {
  data() {
    return {
      loadingAdd: false,
      categoriesObject: [],
      listLang: [],
      dialogCategoryTree: false,
      authorNameSearch: "",
      listAuthors: [],
      authorID: "",
      addDialogAuthor: false,
      publisherNameSearch: "",
      addDialogPublisher: false,
      listPublishers: [],

      bookInformation: {},
      rules: {
        required: (value) => !!value || "Field required.",
        requiredArray: (value) => value != "" || "Field required.",
      },

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Books",
          disabled: false,
          to: "/books",
        },
        {
          text: "Add Book",
          disabled: true,
        },
      ],
    };
  },
  created() {
    if (this.$route.params.bookData == null) {
      this.$router.push({ name: "Books" }).catch(() => {});
      return false;
    }
    this.bookInformation = this.$route.params.bookData.BookInformation;
    this.bookInformation.bookdsecription = this.$route.params.bookData.BookInformation.bookdsecription;
    this.bookInformation.isdownloadable = true;
    this.bookInformation.langid = this.bookInformation.Lang.langid;
    this.bookInformation.booklink = "";
    // this.bookInformation.bookdsecription = "ddd";
    this.getAllLang();
    this.getAllAuthors();
    this.getAllPublishers();
  },

  components: {
    Breadcrumbs,
    SelectTreeCategory,
    AddAuthor,
    AddPublisher,
  },

  methods: {
    submit() {
      let metainfo = [];
      for (
        let index = 0;
        index < this.bookInformation.MetaData.length;
        index++
      ) {
        let obj = {};
        obj["meta_name"] = this.bookInformation.MetaData[index]["name"];
        obj["meta_value"] = this.bookInformation.MetaData[index]["value"];

        metainfo.push(obj);
      }
      this.bookInformation.metainfo = metainfo;
      if (this.$refs.form.validate() != false) {
        this.loadingAdd = true;
        let DataForm = {
          Param: this.bookInformation,
          API: "/admin/uploader",
        };
        this.$store
          .dispatch("PutToAPI", DataForm)
          .then((response) => {
            this.loadingAdd = false;
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.$router.push({ name: "Books" }).catch(() => {});
          })
          .catch((error) => {
            this.loadingAdd = false;
            this.$store.dispatch(
              "PushErrorMsg",
              error.data.data[Object.keys(error.data.data)[0]]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.listLang = response["data"]["data"];
      });
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.categoriesObject = vals;
      let categoryID = [];
      for (let index = 0; index < vals.length; index++) {
        categoryID.push(vals[index]["categoryid"]);
      }
      this.dialogCategoryTree = false;
      this.bookInformation.category = categoryID;
    },
    removerMeta(index) {
      this.bookInformation.MetaData.splice(index, 1);
    },
    getAllAuthors() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/author?per_page=20&filter[authorname]=" +
            this.authorNameSearch
        )
        .then((response) => {
          this.listAuthors = response["data"]["data"];
          this.listAuthors.push({authorid: this.bookInformation.author.authorid, authorname: this.bookInformation.author.authorname})
      });
    },
    searchAuthor() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllAuthors();
      }
    },
    DialogClose() {
      this.addDialogAuthor = false;
      this.addDialogPublisher = false;
      this.getAllAuthors();
    },
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/publisher?per_page=20&filter[publishername]=" +
            this.publisherNameSearch
        )
        .then((response) => {
          this.listPublishers = response["data"]["data"];
          if(this.bookInformation.publisher.publisherid){
            this.listPublishers.push({publisherid: this.bookInformation.publisher.publisherid, publishername: this.bookInformation.publisher.publishername , year: this.bookInformation.publisher.year})
          }
          // if(this.bookInformation.publisher.year == 101 ){
          //   this.bookInformation.publisher.year = ''
          // }
        });
    },
    searchPublishers() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllPublishers();
      }
    },
    addMeta() {
      this.bookInformation.MetaData.push({ name: "", value: "" });
    },
  },
};
</script>